import { FC } from 'react';

import Section from 'layouts/Section/Section';

import ResponsiveCarousel from 'components/ResponsiveCarousel/ResponsiveCarousel';
import Title from 'components/Title/Title';

import { useMobileDesign } from 'hooks/useMobileDesign';

import AdvisorCard from './AdvisorCard';
import config from './config';
import styles from './styles.module.scss';

const Advisors = () => {
  return (
    <Section>
      <Title title="Joblio Advisors">
        The Joblio Advisors provide vital global representation and insights,
        reinforcing our mission with their recognition and unwavering support.
      </Title>
      <ResponsiveCarousel
        slidesToShow={4}
        responsive={[
          { breakpoint: 992, settings: { slidesToShow: 2 } },
          { breakpoint: 620, settings: { slidesToShow: 1 } }
        ]}
      >
        {config.map((advisor, index) => (
          <AdvisorCard
            key={index}
            name={advisor.name}
            location={advisor.location}
            image={advisor.image}
          />
        ))}
      </ResponsiveCarousel>
    </Section>
  );
};

export default Advisors;
